import { useQuery } from '@tanstack/react-query'

import type { BookingDetail } from '../../types/booking.js'

import { apiClient } from '../../lib/client.js'
import { bookingKeys } from './keys.js'

export const useGetMyBookingByRefQuery = (bookingRef: string | undefined) =>
  useQuery({
    enabled: !!bookingRef,
    queryFn: async () => {
      const response = await apiClient.client.get<BookingDetail>(`/me/bookings/${bookingRef}`)
      return response.data
    },
    queryKey: bookingKeys.myBookingByRef(bookingRef ?? ''),
  })
